import GoogleMapsLoader from 'google-maps'

export default (ctx, inject) => {
	// GoogleMapsLoader.KEY = 'AIzaSyD3ILQJ1JK9YQOf7Yc3Vaw8Lrt8TfBwoV4' // Dev only
	GoogleMapsLoader.KEY = 'AIzaSyDIT7IWYAmsxsFZXdz07udcjspQ-N2EEUM'
	GoogleMapsLoader.VERSION = '3.44' // '3.39'
	GoogleMapsLoader.REGION = 'TH'
	GoogleMapsLoader.LANGUAGE = 'th'
	GoogleMapsLoader.LIBRARIES = ['places', 'geometry']
	inject('googleMapsLoader', GoogleMapsLoader)
}
